// How the funding settings are grouped on the console (docs/PARTNER_API.md § 4.5, "Cấu hình"): the few a partner's
// fund needs first, the rest folded under plain headings. A setting no section names still shows (in "Other").
import { type SettingsSection } from '../components/SettingsForm';

const PARTNER_BASICS = ['funding.enabled', 'funding.advanceLimit', 'funding.advanceDueDays', 'funding.lowBalance'];
const PARTNER_OVERDUE = [
  'funding.overdueAction',
  'funding.advanceReminderDays',
  'funding.overdueFreezeDays',
  'funding.doubtfulDays',
  'funding.writeOffDays',
];
const PARTNER_LOAD_CHECKS = ['funding.velocityHour', 'funding.velocityDay'];

/** PartnerDetail › Funding. */
export const PARTNER_FUNDING_SECTIONS: readonly SettingsSection[] = [
  { title: 'Basics', keys: PARTNER_BASICS, open: true },
  {
    title: 'Advanced: when an advance is overdue',
    note: 'Reminders, freezing loads, doubtful debt and write-off. Empty fields follow QOR’s defaults.',
    keys: PARTNER_OVERDUE,
  },
  {
    title: 'Advanced: loads that wait for a second admin',
    note: 'How much this partner may load in an hour or a day before loads wait for approval.',
    keys: PARTNER_LOAD_CHECKS,
  },
];

/** Funding (QOR-wide). */
export const PLATFORM_FUNDING_SECTIONS: readonly SettingsSection[] = [
  {
    title: 'Lending and debt',
    note: 'How much of QOR’s own money may be lent to partners, in all and to one partner.',
    keys: [
      'risk.capitalAtRisk',
      'funding.advanceCapTotal',
      'risk.exposureWarnPercent',
      'risk.exposureCriticalPercent',
      'risk.exposureBlockPercent',
      'risk.concentrationPercent',
    ],
  },
  {
    title: 'Money at the processor',
    note: 'When QOR must wire more to the processor: how long the money lasts, deposits not wired on yet, coverage.',
    keys: [
      'risk.runwayWarnDays',
      'risk.runwayCriticalDays',
      'risk.unwiredWarnDays',
      'risk.unwiredCriticalDays',
      'funding.processorLow',
      'funding.processorBuffer',
      'funding.warnRatio',
      'funding.criticalRatio',
      'funding.reconcileTolerance',
      'funding.snapshotMaxAgeHours',
    ],
  },
  {
    title: 'Alerts, checks and the daily report',
    keys: [
      'funding.alertRepeatHours',
      'funding.unknownAlertMinutes',
      'risk.anomalyMultiple',
      'funding.depositDuplicateDays',
      'risk.digestHourUtc',
    ],
  },
  {
    title: 'Defaults for every partner',
    note: 'Used by each partner that has no value of its own (set one in the partner’s Funding tab).',
    keys: [...PARTNER_BASICS, ...PARTNER_OVERDUE, ...PARTNER_LOAD_CHECKS],
  },
];
